import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en.json';
import esTranslation from './locales/es.json';
import frTranslation from './locales/fr.json';
import itTranslation from './locales/it.json';
import ptTranslation from './locales/pt.json';
import ruTranslation from './locales/ru.json';
import cnTranslation from './locales/cn.json';
import hiTranslation from './locales/hi.json';
import deTranslation from './locales/de.json';
import arTranslation from './locales/ar.json';

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: enTranslation },
        es: { translation: esTranslation },
        fr: { translation: frTranslation },
        it: { translation: itTranslation },
        pt: { translation: ptTranslation },
        ru: { translation: ruTranslation },
        cn: { translation: cnTranslation },
        hi: { translation: hiTranslation },
        de: { translation: deTranslation },
        ar: { translation: arTranslation }
    },
    lng: 'es',
    fallbackLng: 'en',
    interpolation: { escapeValue: false }
});
export default i18n;